import { FC } from 'react';

import { DeleteBin5Line, Search2Line, TrashIcon } from '@assets/icons';
import { useBreakpoint } from '@contexts/breakpoints';
import CustomIcon from '@components/utils/CustomIcon';
import Collapse from '@components/Collapse/Collapse';
import { Row } from '@components/formStyles';

import {
  StyledNameFilter,
  NameFilterInputWrapper,
  NameFilterInput,
  NameFilterTitle,
  ClearContainer,
  NameFilterSearchButton,
  CollapsableStyledNameFilter,
  CollapsableNameFilterInputWrapper,
  InputButtonWrapper,
} from './NameFilterStyle';

export interface NameFilterProps {
  title?: string;
  name: string;
  setName: (val: string) => void;
  placeholder: string;
  handleSearch: (name: string) => void;
  inputWrapperClassName?: string;
  withClear?: boolean;
  handleClearKeywordsFilter?: () => void;
  collapsable?: boolean;
}

const NameFilter: FC<NameFilterProps> = ({
  title,
  name,
  setName,
  placeholder,
  handleSearch,
  inputWrapperClassName,
  withClear,
  handleClearKeywordsFilter,
  collapsable,
}) => {
  const screens = useBreakpoint();

  const handleSearchButtonClicked = (): void => {
    handleSearch(name);
  };

  const clear = () => {
    setName('');
    handleSearch('');
    handleClearKeywordsFilter?.();
  };

  return collapsable ? (
    <Collapse
      panelProps={{
        header: <NameFilterTitle>{title}</NameFilterTitle>,
        key: 'searchByName',
      }}
    >
      <CollapsableStyledNameFilter>
        <CollapsableNameFilterInputWrapper className={inputWrapperClassName}>
          <NameFilterInput
            prefix={
              <CustomIcon
                icon={Search2Line}
                paletteColor='grey500'
                fontSize={20}
              />
            }
            placeholder={placeholder}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </CollapsableNameFilterInputWrapper>
        {withClear && name ? (
          <ClearContainer onClick={clear}>
            <span>Aramayı Temizle</span>
            <CustomIcon
              icon={TrashIcon}
              paletteColor='tomato'
              width={18}
              height={20}
            />
          </ClearContainer>
        ) : null}
        {screens.xl ? (
          <NameFilterSearchButton
            disabled={!name}
            onClick={handleSearchButtonClicked}
          >
            Ara
          </NameFilterSearchButton>
        ) : null}
      </CollapsableStyledNameFilter>
    </Collapse>
  ) : (
    <StyledNameFilter>
      <Row>
        <NameFilterTitle>{title}</NameFilterTitle>
        {withClear && name ? (
          <ClearContainer onClick={clear}>
            <CustomIcon
              icon={DeleteBin5Line}
              paletteColor='tomato'
              width={16}
              height={16}
            />
          </ClearContainer>
        ) : null}
      </Row>
      <InputButtonWrapper>
        <NameFilterInputWrapper className={inputWrapperClassName}>
          <NameFilterInput
            prefix={
              <CustomIcon
                icon={Search2Line}
                paletteColor='grey500'
                fontSize={20}
              />
            }
            placeholder={placeholder}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </NameFilterInputWrapper>
        {screens.xl ? (
          <NameFilterSearchButton
            disabled={!name}
            onClick={handleSearchButtonClicked}
          >
            Ara
          </NameFilterSearchButton>
        ) : null}
      </InputButtonWrapper>
    </StyledNameFilter>
  );
};

export default NameFilter;
